import i from "haversine-distance";
const c = (n, s) => s.map((t) => {
  const e = i(n, { lat: t.latitude, lng: t.longitude });
  return {
    ...t,
    distanceInMeters: e
  };
}).sort((t, e) => t.distanceInMeters - e.distanceInMeters);
export {
  c as extendStationsWithDistanceAndSortByUserPosition
};
